import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {environment} from 'src/environments/environment';
import {CustomsValidators} from '../../validators/custom.validators';
import {throwError} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SaaDelegateService {
  urlSearchPeople: string;
  urlSaaApprover: string;
  urlPeopleSearch: string;

  constructor(private http: HttpClient) {
    this.urlSearchPeople = `${environment.bffBaseUrl}/pages/people-search/saaDelegates`;
    this.urlSaaApprover = `${environment.bffBaseUrl}/pages/saa-delegate`;
    this.urlPeopleSearch = `${environment.bffBaseUrl}/pages/people-search`;

  }

  getPersonSearch(person: string) {
    const urlBuilder = this.urlSearchPeople + '?searchData=' + person;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder) : throwError(CustomsValidators.msgNotValidUrl);
  }


  getAllDelegates(page, limit, filterUrl) {
    const urlBuilder = this.urlSaaApprover + '?page=' + page + '&limit=' + limit + filterUrl;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder) : throwError(CustomsValidators.msgNotValidUrl);
  }

  getOneDelegate(id) {
    const urlBuilder = this.urlSaaApprover + '/' + id;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder) : throwError(CustomsValidators.msgNotValidUrl);
  }


  postDelegate(payload) {
    const urlBuilder = this.urlSaaApprover;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.post(urlBuilder, payload) : throwError(CustomsValidators.msgNotValidUrl);
  }


  updateDelegate(payloadUpdate) {
    const urlBuilder = this.urlSaaApprover + '/' + payloadUpdate.Id;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.patch(urlBuilder, payloadUpdate)
      : throwError(CustomsValidators.msgNotValidUrl);
  }

  deleteDelegate(id) {
    const urlBuilder = this.urlSaaApprover + '/' + id;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.delete(urlBuilder) : throwError(CustomsValidators.msgNotValidUrl);
  }


  getPeropleSearchByletter(searchname) {
    const urlBuilder = this.urlPeopleSearch + '/byOne?searchData=' + searchname;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder) : throwError(CustomsValidators.msgNotValidUrl);

  }


}
